import { createContext, Dispatch, FCWithChildren, SetStateAction, useContext, useState } from 'react';
import { PaginationState } from '@interfaces/models/negotiation/domain/BuyingOffer';
import { SellingOffersProductsItem } from '@interfaces/models/negotiation/domain/SellingOffersProduct';
import { SellingOffersNegotiationData } from '@interfaces/models/negotiation/domain/SellingOffersNegotiation';

interface SellingOffersContextProps {
  sellingOffersProductsList: SellingOffersProductsItem[];
  setSellingOffersProductsList: Dispatch<SetStateAction<SellingOffersProductsItem[]>>;
  sellingOffersNegotiationsList: SellingOffersNegotiationData[];
  setSellingOffersNegotiationsList: Dispatch<SetStateAction<SellingOffersNegotiationData[]>>;
  sellingOffersProductsPaginationMeta: PaginationState;
  setSellingOffersProductsPaginationMeta: Dispatch<SetStateAction<PaginationState>>;
  sellingOffersNegotiationsPaginationMeta: PaginationState;
  setSellingOffersNegotiationsPaginationMeta: Dispatch<SetStateAction<PaginationState>>;
}

const SellingOffersContext = createContext<SellingOffersContextProps>({} as SellingOffersContextProps);

const SellingOffersProvider: FCWithChildren = ({ children }) => {
  const [sellingOffersProductsList, setSellingOffersProductsList] = useState<SellingOffersProductsItem[]>([]);
  const [sellingOffersNegotiationsList, setSellingOffersNegotiationsList] = useState<SellingOffersNegotiationData[]>(
    [],
  );
  const [sellingOffersProductsPaginationMeta, setSellingOffersProductsPaginationMeta] = useState<PaginationState>(null);
  const [sellingOffersNegotiationsPaginationMeta, setSellingOffersNegotiationsPaginationMeta] =
    useState<PaginationState>(null);

  const value = {
    sellingOffersProductsList,
    setSellingOffersProductsList,
    sellingOffersNegotiationsList,
    setSellingOffersNegotiationsList,
    sellingOffersProductsPaginationMeta,
    setSellingOffersProductsPaginationMeta,
    sellingOffersNegotiationsPaginationMeta,
    setSellingOffersNegotiationsPaginationMeta,
  };

  return <SellingOffersContext.Provider value={value}>{children}</SellingOffersContext.Provider>;
};

const useSellingOffers = () => useContext(SellingOffersContext);

export { SellingOffersProvider, useSellingOffers };
